/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetPartitionPartitionsPartitionIdGetRequest = {
  partitionId: string;
};

/** @internal */
export const GetPartitionPartitionsPartitionIdGetRequest$inboundSchema:
  z.ZodType<
    GetPartitionPartitionsPartitionIdGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    partition_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "partition_id": "partitionId",
    });
  });
/** @internal */
export type GetPartitionPartitionsPartitionIdGetRequest$Outbound = {
  partition_id: string;
};

/** @internal */
export const GetPartitionPartitionsPartitionIdGetRequest$outboundSchema:
  z.ZodType<
    GetPartitionPartitionsPartitionIdGetRequest$Outbound,
    z.ZodTypeDef,
    GetPartitionPartitionsPartitionIdGetRequest
  > = z.object({
    partitionId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      partitionId: "partition_id",
    });
  });

export function getPartitionPartitionsPartitionIdGetRequestToJSON(
  getPartitionPartitionsPartitionIdGetRequest:
    GetPartitionPartitionsPartitionIdGetRequest,
): string {
  return JSON.stringify(
    GetPartitionPartitionsPartitionIdGetRequest$outboundSchema.parse(
      getPartitionPartitionsPartitionIdGetRequest,
    ),
  );
}
export function getPartitionPartitionsPartitionIdGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetPartitionPartitionsPartitionIdGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetPartitionPartitionsPartitionIdGetRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetPartitionPartitionsPartitionIdGetRequest' from JSON`,
  );
}
